var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.37494 0.225004C4.72494 -0.0699963 5.28994 -0.0699963 5.62994 0.225004L6.41994 0.900004C6.56994 1.025 6.85494 1.13 7.05494 1.13H7.90494C8.43494 1.13 8.86994 1.565 8.86994 2.095V2.945C8.86994 3.145 8.97494 3.425 9.09994 3.575L9.77494 4.365C10.0699 4.715 10.0699 5.28 9.77494 5.62L9.09994 6.41C8.97494 6.56 8.86994 6.84 8.86994 7.04V7.89C8.86994 8.42 8.43494 8.855 7.90494 8.855H7.05494C6.85494 8.855 6.57494 8.96 6.42494 9.085L5.63494 9.76C5.28494 10.055 4.71994 10.055 4.37994 9.76L3.58994 9.085C3.43994 8.96 3.15494 8.855 2.95994 8.855H2.08494C1.55494 8.855 1.11994 8.42 1.11994 7.89V7.035C1.11994 6.84 1.01994 6.555 0.894941 6.41L0.219941 5.615C-0.0700586 5.27 -0.0700586 4.71 0.219941 4.365L0.894941 3.57C1.01994 3.42 1.11994 3.14 1.11994 2.945V2.1C1.11994 1.57 1.55494 1.135 2.08494 1.135H2.94994C3.14994 1.135 3.42994 1.03 3.57994 0.905004L4.37494 0.225004Z",
    fill: "#D99036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthInfo);
export default __webpack_public_path__ + "static/media/auth-info.2f48a5d1ca137ea94e9480404aa0f7af.svg";
export { ForwardRef as ReactComponent };